"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = exports.MessageKindTypes = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Box_1 = require("../Box");
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const IcErrorFilled_1 = __importDefault(require("../Icons/IcErrorFilled"));
const IcInfoFilled_1 = __importDefault(require("../Icons/IcInfoFilled"));
const IcSuccessFilled_1 = __importDefault(require("../Icons/IcSuccessFilled"));
const IcWarningFilled_1 = __importDefault(require("../Icons/IcWarningFilled"));
const types_1 = require("../types");
const Typography_1 = require("../Typography");
const defaultFunction = () => {
    return undefined;
};
exports.MessageKindTypes = types_1.tuple('information', 'error', 'warning', 'success');
const Message = (props) => {
    const { forwardedRef, message, title, className, kind = 'error', actionText, onActionClick = defaultFunction } = props, restProps = __rest(props, ["forwardedRef", "message", "title", "className", "kind", "actionText", "onActionClick"]);
    const finalClassName = classnames_1.default(`${kind}-cl-message`, className);
    const getBackground = (kind) => {
        switch (kind) {
            case 'warning':
                return 'warning-highlight';
            case 'error':
                return 'error-highlight';
            case 'information':
                return 'information-highlight';
            default:
                return 'success-highlight';
        }
    };
    const getIcon = (kind) => {
        switch (kind) {
            case 'warning':
                return react_1.default.createElement(IcWarningFilled_1.default, { fill: 'neutral-primary' });
            case 'error':
                return react_1.default.createElement(IcErrorFilled_1.default, { fill: 'error' });
            case 'information':
                return react_1.default.createElement(IcInfoFilled_1.default, { fill: 'information' });
            default:
                return react_1.default.createElement(IcSuccessFilled_1.default, { fill: 'success' });
        }
    };
    return (react_1.default.createElement(Box_1.Box, Object.assign({ ref: forwardedRef, className: finalClassName, borderRadius: 'xs', padding: 'sm', paddingLeft: 'xs', background: getBackground(kind), direction: 'row', color: 'neutral-primary', alignItems: 'start', role: 'status' }, restProps),
        react_1.default.createElement(Box_1.Box, { marginRight: 'xs', role: 'img', "aria-label": `${kind}-icon` }, getIcon(kind)),
        react_1.default.createElement(Box_1.Box, { direction: 'column' },
            title && (react_1.default.createElement(Typography_1.Typography, { type: 'title-sm', marginBottom: 'xxs' }, title)),
            react_1.default.createElement(Typography_1.Typography, { type: 'paragraph-sm' }, message),
            actionText && (react_1.default.createElement(Typography_1.Typography, { type: 'label-md', className: 'action-cta', marginTop: 'xs', onClick: onActionClick, color: 'interaction-secondary', "aria-label": actionText, tabIndex: 0 }, actionText)))));
};
exports.Message = Message;
exports.Message.displayName = 'Message';
exports.default = ForwardRefHOC_1.default(exports.Message);
